import { useFinancieelStore } from '../../stores';

function formatAmount(amount: number): string {
  return new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
}

export function Resultaat() {
  const { omzetData, kostenData } = useFinancieelStore();

  // Only show when both omzet and kosten are available
  if (omzetData.length === 0 || kostenData.length === 0) return null;

  const totalOmzet = omzetData.reduce((s, r) => s + r.total_excl, 0);
  const totalKosten = kostenData.reduce((s, r) => s + r.net_amount, 0);
  const resultaat = totalOmzet - totalKosten;

  const cards = [
    {
      label: 'Omzet',
      value: totalOmzet,
      subtitle: 'uit Salesforce',
      color: 'text-main',
    },
    {
      label: 'Kosten',
      value: totalKosten,
      subtitle: 'uit Yuki',
      color: 'text-main',
    },
    {
      label: 'Resultaat',
      value: resultaat,
      subtitle: 'bruto',
      color: resultaat >= 0 ? 'text-emerald-600' : 'text-red-600',
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {cards.map(card => (
        <div key={card.label} className="bg-white rounded-card shadow-card p-5">
          <p className="text-xs font-medium text-muted uppercase tracking-wider mb-1">{card.label}</p>
          <p className={`text-2xl font-semibold tabular-nums ${card.color}`}>
            {formatAmount(card.value)}
          </p>
          <p className="text-xs text-gray-400 mt-1">{card.subtitle}</p>
        </div>
      ))}
    </div>
  );
}
